window.theme = window.theme || {};
window.Shopify = window.Shopify || {};

theme.config = {
    bpSmall: false,
    stickyHeader: false
};

(function() {

    'use strict';

    theme.delegate = {
        on: function(event, callback, options){
        if( !this.namespaces ) // save the namespaces on the DOM element itself
            this.namespaces = {};
    
        this.namespaces[event] = callback;
        options = options || false;
    
        this.addEventListener(event.split('.')[0], callback, options);
        return this;
        },
        off: function(event) {
        if (!this.namespaces) { return }
        this.removeEventListener(event.split('.')[0], this.namespaces[event]);
        delete this.namespaces[event];
        return this;
        }
    };

    theme.a11y = {
      trapFocus: function(options) {
        var eventsName = {
          focusin: options.namespace ? 'focusin.' + options.namespace : 'focusin',
          focusout: options.namespace
            ? 'focusout.' + options.namespace
            : 'focusout',
          keydown: options.namespace
            ? 'keydown.' + options.namespace
            : 'keydown.handleFocus'
        };
    
        // Get every possible visible focusable element
        var focusableEls = options.container.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])');
        var elArray = [].slice.call(focusableEls);
        var focusableElements = elArray.filter(el => el.offsetParent !== null);
    
        var firstFocusable = focusableElements[0];
        var lastFocusable = focusableElements[focusableElements.length - 1];
    
        if (!options.elementToFocus) {
          options.elementToFocus = options.container;
        }
    
        options.container.setAttribute('tabindex', '-1');
        options.elementToFocus.focus();
    
        document.documentElement.off('focusin');
        document.documentElement.on(eventsName.focusout, function() {
          document.documentElement.off(eventsName.keydown);
        });
    
        document.documentElement.on(eventsName.focusin, function(evt) {
          if (evt.target !== options.container && evt.target !== lastFocusable && evt.target !== firstFocusable) return;
    
          document.documentElement.on(eventsName.keydown, function(evt) {
            _manageFocus(evt);
          });
        });
    
        function _manageFocus(evt) {
          if (evt.keyCode !== 9) return;
          /**
           * On the first focusable element and tab backward,
           * focus the last element
           */
          if (evt.target === lastFocusable && !evt.shiftKey) {
            evt.preventDefault();
            firstFocusable.focus();
          }
        }
      },
      removeTrapFocus: function(options) {
        var eventName = options.namespace
          ? 'focusin.' + options.namespace
          : 'focusin';
    
        if (options.container) {
          options.container.removeAttribute('tabindex');
        }
    
        document.documentElement.off(eventName);
      },
    
      lockMobileScrolling: function(namespace, element) {
        var el = element ? element : document.documentElement;
        document.documentElement.classList.add('lock-scroll');
        el.on('touchmove' + namespace, function() {
          return true;
        });
      },
    
      unlockMobileScrolling: function(namespace, element) {
        document.documentElement.classList.remove('lock-scroll');
        var el = element ? element : document.documentElement;
        el.off('touchmove' + namespace);
      }
    };

    window.on = Element.prototype.on = theme.delegate.on;
    window.off = Element.prototype.off = theme.delegate.off;

    theme.utils = {
        defaultTo: function(value, defaultValue) {
          return (value == null || value !== value) ? defaultValue : value
        },
      
        wrap: function(el, wrapper) {
          el.parentNode.insertBefore(wrapper, el);
          wrapper.appendChild(el);
        },
      
        debounce: function(wait, callback, immediate) {
          var timeout;
          return function() {
            var context = this, args = arguments;
            var later = function() {
              timeout = null;
              if (!immediate) callback.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) callback.apply(context, args);
          }
        },
      
        throttle: function(limit, callback) {
          var waiting = false;
          return function () {
            if (!waiting) {
              callback.apply(this, arguments);
              waiting = true;
              setTimeout(function () {
                waiting = false;
              }, limit);
            }
          }
        },
      
        prepareTransition: function(el, callback) {
          el.addEventListener('transitionend', removeClass);
      
          function removeClass(evt) {
            el.classList.remove('is-transitioning');
            el.removeEventListener('transitionend', removeClass);
          }
      
          el.classList.add('is-transitioning');
          el.offsetWidth; // check offsetWidth to force the style rendering
      
          if (typeof callback === 'function') {
            callback();
          }
        },
      
        // _.compact from lodash
        // Creates an array with all falsey values removed. The values `false`, `null`,
        // `0`, `""`, `undefined`, and `NaN` are falsey.
        // _.compact([0, 1, false, 2, '', 3]);
        // => [1, 2, 3]
        compact: function(array) {
          var index = -1,
              length = array == null ? 0 : array.length,
              resIndex = 0,
              result = [];
      
          while (++index < length) {
            var value = array[index];
            if (value) {
              result[resIndex++] = value;
            }
          }
          return result;
        },
      
        serialize: function(form) {
          var arr = [];
          Array.prototype.slice.call(form.elements).forEach(function(field) {
            if (
              !field.name ||
              field.disabled ||
              ['file', 'reset', 'submit', 'button'].indexOf(field.type) > -1
            )
              return;
            if (field.type === 'select-multiple') {
              Array.prototype.slice.call(field.options).forEach(function(option) {
                if (!option.selected) return;
                arr.push(
                  encodeURIComponent(field.name) +
                    '=' +
                    encodeURIComponent(option.value)
                );
              });
              return;
            }
            if (['checkbox', 'radio'].indexOf(field.type) > -1 && !field.checked)
              return;
            arr.push(
              encodeURIComponent(field.name) + '=' + encodeURIComponent(field.value)
            );
          });
          return arr.join('&');
        }
    };

    theme.Sections = function Sections() {
        this.constructors = {};
        this.instances = [];
      
        document.addEventListener('shopify:section:load', this._onSectionLoad.bind(this));
        document.addEventListener('shopify:section:unload', this._onSectionUnload.bind(this));
        document.addEventListener('shopify:section:select', this._onSelect.bind(this));
        document.addEventListener('shopify:section:deselect', this._onDeselect.bind(this));
        document.addEventListener('shopify:block:select', this._onBlockSelect.bind(this));
        document.addEventListener('shopify:block:deselect', this._onBlockDeselect.bind(this));
    };
      
    theme.Sections.prototype = Object.assign({}, theme.Sections.prototype, {
        _createInstance: function(container, constructor, scope) {
          var id = container.getAttribute('data-section-id');
          var type = container.getAttribute('data-section-type');
      
          constructor = constructor || this.constructors[type];
      
          if (typeof constructor === 'undefined') {
            return;
          }
      
          // If custom scope passed, check to see if instance
          // is already initialized so we don't double up
          if (scope) {
            var instanceExists = this._findInstance(id);
            if (instanceExists) {
              this._removeInstance(id);
            }
          }
      
          // If a section fails to init, handle the error without letting all subsequest section registers to fail
          try {
            var instance = Object.assign(new constructor(container), {
              id: id,
              type: type,
              container: container
            });
            this.instances.push(instance);
          } catch (e) {
            console.error(e);
          }
        },
      
        _findInstance: function(id) {
          for (var i = 0; i < this.instances.length; i++) {
            if (this.instances[i].id === id) {
              return this.instances[i];
            }
          }
        },
      
        _removeInstance: function(id) {
          var i = this.instances.length;
          var instance;
      
          while(i--) {
            if (this.instances[i].id === id) {
              instance = this.instances[i];
              this.instances.splice(i, 1);
              break;
            }
          }
      
          return instance;
        },
      
        _onSectionLoad: function(evt, subSection, subSectionId) {
          if (window.AOS) { AOS.refreshHard() }
          if (theme && theme.initGlobals) {
            theme.initGlobals();
          }
      
          var container = subSection ? subSection : evt.target;
          var section = subSection ? subSection : evt.target.querySelector('[data-section-id]');
      
          if (!section) {
            return;
          }
      
          this._createInstance(section);
      
          var instance = subSection ? subSectionId : this._findInstance(evt.detail.sectionId);
      
          // Check if we have subsections to load
          var haveSubSections = container.querySelectorAll('[data-subsection]');
          if (haveSubSections.length) {
            this.loadSubSections(container);
          }
      
          // Run JS only in case of the section being selected in the editor
          // before merchant clicks "Add"
          if (instance && typeof instance.onLoad === 'function') {
            instance.onLoad(evt);
          }
      
          // Force editor to trigger scroll event when loading a section
          setTimeout(function() {
            window.dispatchEvent(new Event('scroll'));
          }, 200);
        },
      
        _onSectionUnload: function(evt) {
          this.instances = this.instances.filter(function(instance) {
            var isEventInstance = instance.id === evt.detail.sectionId;
      
            if (isEventInstance) {
              if (typeof instance.onUnload === 'function') {
                instance.onUnload(evt);
              }
            }
      
            return !isEventInstance;
          });
        },
      
        loadSubSections: function(scope) {
          if (!scope) {
            return;
          }
      
          var sections = scope.querySelectorAll('[data-section-id]');
      
          sections.forEach(el => {
            this._onSectionLoad(null, el, el.dataset.sectionId);
          });
        },
      
        _onSelect: function(evt) {
          var instance = this._findInstance(evt.detail.sectionId);
      
          if (
            typeof instance !== 'undefined' &&
            typeof instance.onSelect === 'function'
          ) {
            instance.onSelect(evt);
          }
        },
      
        _onDeselect: function(evt) {
          var instance = this._findInstance(evt.detail.sectionId);
      
          if (
            typeof instance !== 'undefined' &&
            typeof instance.onDeselect === 'function'
          ) {
            instance.onDeselect(evt);
          }
        },
      
        _onBlockSelect: function(evt) {
          var instance = this._findInstance(evt.detail.sectionId);
      
          if (
            typeof instance !== 'undefined' &&
            typeof instance.onBlockSelect === 'function'
          ) {
            instance.onBlockSelect(evt);
          }
        },
      
        _onBlockDeselect: function(evt) {
          var instance = this._findInstance(evt.detail.sectionId);
      
          if (
            typeof instance !== 'undefined' &&
            typeof instance.onBlockDeselect === 'function'
          ) {
            instance.onBlockDeselect(evt);
          }
        },
      
        register: function(type, constructor, scope) {
          this.constructors[type] = constructor;
      
          var sections = document.querySelectorAll('[data-section-type="' + type + '"]');
      
          if (scope) {
            sections = scope.querySelectorAll('[data-section-type="' + type + '"]');
          }
      
          sections.forEach(
            function(container) {
              this._createInstance(container, constructor, scope);
            }.bind(this)
          );
        },
      
        reinit: function(section) {
          for (var i = 0; i < this.instances.length; i++) {
            var instance = this.instances[i];
            if (instance['type'] === section) {
              if (typeof instance.forceReload === 'function') {
                instance.forceReload();
              }
            }
          }
        }
    });

    theme.collapsibles = (function() {
        var selectors = {
        trigger: '.collapsible-trigger',
        module: '.collapsible-content',
        moduleInner: '.collapsible-content__inner',
        tabs: '.collapsible-trigger--tab'
        };
    
        var classes = {
        hide: 'hide',
        open: 'is-open',
        autoHeight: 'collapsible--auto-height',
        tabs: 'collapsible-trigger--tab'
        };
    
        var namespace = '.collapsible';
    
        var isTransitioning = false;
  
        function init(scope) {
        var el = scope ? scope : document;
        el.querySelectorAll(selectors.trigger).forEach(trigger => {
            var state = trigger.classList.contains(classes.open);
            trigger.setAttribute('aria-expanded', state);
    
            trigger.off('click' + namespace);
            trigger.on('click' + namespace, toggle);
        });
        }
  
        function toggle(evt) {
        if (isTransitioning) {
            return;
        }
    
        isTransitioning = true;
    
        var el = evt.currentTarget;
        var isOpen = el.classList.contains(classes.open);
        var isTab = el.classList.contains(classes.tabs);
        var moduleId = el.getAttribute('aria-controls');
        var container = document.getElementById(moduleId);
    
        if (!moduleId) {
            moduleId = el.dataset.controls;
        }
    
        // No ID, bail
        if (!moduleId) {
            return;
        }
    
        // If container=null, there isn't a matching ID.
        // Check if data-id is set instead. Could be multiple.
        // Select based on being in the same parent div.
        if (!container) {
            var multipleMatches = document.querySelectorAll('[data-id="' + moduleId + '"]');
            if (multipleMatches.length > 0) {
            container = el.parentNode.querySelector('[data-id="' + moduleId + '"]');
            }
        }
    
        if (!container) {
            isTransitioning = false;
            return;
        }
    
        var height = container.querySelector(selectors.moduleInner).offsetHeight;
        var isAutoHeight = container.classList.contains(classes.autoHeight);
        var parentCollapsibleEl = container.parentNode.closest(selectors.module);
        var childHeight = height;
    
        if (isTab) {
            if(isOpen) {
            isTransitioning = false;
            return;
            }
    
            var newModule;
            document.querySelectorAll(selectors.tabs + '[data-id="'+ el.dataset.id +'"]').forEach(el => {
            el.classList.remove(classes.open);
            newModule = document.querySelector('#' + el.getAttribute('aria-controls'));
            setTransitionHeight(newModule, 0, true);
            });
        }
    
        // If isAutoHeight, set the height to 0 just after setting the actual height
        // so the closing animation works nicely
        if (isOpen && isAutoHeight) {
            setTimeout(function() {
            height = 0;
            setTransitionHeight(container, height, isOpen, isAutoHeight);
            }, 0);
        }
    
        if (isOpen && !isAutoHeight) {
            height = 0;
        }
    
        el.setAttribute('aria-expanded', !isOpen);
        if (isOpen) {
            el.classList.remove(classes.open);
        } else {
            el.classList.add(classes.open);
        }
    
        setTransitionHeight(container, height, isOpen, isAutoHeight);
    
        // If we are in a nested collapsible element like the mobile nav,
        // also set the parent element's height
        if (parentCollapsibleEl) {
            var parentHeight = parentCollapsibleEl.style.height;
    
            if (isOpen && parentHeight === 'auto') {
            childHeight = 0; // Set childHeight to 0 if parent is initially opened
            }
    
            var totalHeight = isOpen
                            ? parentCollapsibleEl.offsetHeight - childHeight
                            : height + parentCollapsibleEl.offsetHeight;
    
            setTransitionHeight(parentCollapsibleEl, totalHeight, false, false);
        }
    
        // If Shopify Product Reviews app installed,
        // resize container on 'Write review' click
        // that shows form
        if (window.SPR) {
            var btn = container.querySelector('.spr-summary-actions-newreview');
            if (!btn) { return }
            btn.off('click' + namespace);
            btn.on('click' + namespace, function() {
            height = container.querySelector(selectors.moduleInner).offsetHeight;
            setTransitionHeight(container, height, isOpen, isAutoHeight);
            });
        }
        }
    
        function setTransitionHeight(container, height, isOpen, isAutoHeight) {
        container.classList.remove(classes.hide);
        theme.utils.prepareTransition(container, function() {
    
            container.style.height = height+'px';
            if (isOpen) {
            container.classList.remove(classes.open);
            } else {
            container.classList.add(classes.open);
            }
        });
    
        if (!isOpen && isAutoHeight) {
            var o = container;
            window.setTimeout(function() {
            o.css('height','auto');
            isTransitioning = false;
            }, 500);
        } else {
            isTransitioning = false;
        }
        }
  
        return {
        init: init
        };
    })();

    theme.Drawers = (function() {
        function Drawers(id, name) {
          this.config = {
            id: id,
            close: '.js-drawer-close',
            open: '.js-drawer-open-' + name,
            openClass: 'js-drawer-open',
            openClassNew: 'js-drawer-new-' + name,
            closingClass: 'js-drawer-closing',
            activeDrawer: 'drawer--is-open',
            namespace: '.drawer-' + name
          };
      
          this.nodes = {
            page: document.querySelector('#MainContent')
          };
      
          this.drawer = document.querySelector('#' + id);
          this.isOpen = false;
      
          if (!this.drawer) {
            return;
          }
      
          this.init();
        }
      
        Drawers.prototype = Object.assign({}, Drawers.prototype, {
          init: function() {
            // Setup open button(s)
            document.querySelectorAll(this.config.open).forEach(openBtn => {
              openBtn.setAttribute('aria-expanded', 'false');
              openBtn.addEventListener('click', this.open.bind(this));
            });
      
            this.drawer.querySelector(this.config.close).addEventListener('click', this.close.bind(this));
      
            // Close modal if a drawer is opened
            document.addEventListener('modalOpen', function() {
              this.close();
            }.bind(this));
          },
      
          open: function(evt, returnFocusEl) {
            if (evt) {
              evt.preventDefault();
            }
      
            if (this.isOpen) {
              return;
            }
      
            // Without this the drawer opens, the click event bubbles up to $nodes.page which closes the drawer.
            if (evt && evt.stopPropagation) {
              evt.stopPropagation();
              // save the source of the click, we'll focus to this on close
              evt.currentTarget.setAttribute('aria-expanded', 'true');
              this.activeSource = evt.currentTarget;
            } else if (returnFocusEl) {
              returnFocusEl.setAttribute('aria-expanded', 'true');
              this.activeSource = returnFocusEl;
            }
      
            theme.utils.prepareTransition(this.drawer, function() {
              this.drawer.classList.add(this.config.activeDrawer);
            }.bind(this));
      
            document.documentElement.classList.add(this.config.openClass);
            document.documentElement.classList.add(this.config.openClassNew);
            this.isOpen = true;
      
            theme.a11y.trapFocus({
              container: this.drawer,
              namespace: 'drawer_focus'
            });
      
            document.dispatchEvent(new CustomEvent('drawerOpen'));
            document.dispatchEvent(new CustomEvent('drawerOpen.' + this.config.id));
      
            this.bindEvents();
          },
      
          close: function(evt) {
            if (!this.isOpen) {
              return;
            }
      
            // Do not close if click event came from inside drawer
            if (evt) {
              if (evt.target.closest('.js-drawer-close')) {
                // Do not close if using the drawer close button
              } else if (evt.target.closest('.drawer')) {
                return;
              }
            }
      
            // deselect any focused form elements
            document.activeElement.blur();
      
            theme.utils.prepareTransition(this.drawer, function() {
              this.drawer.classList.remove(this.config.activeDrawer);
            }.bind(this));
      
            document.documentElement.classList.remove(this.config.openClass);
            document.documentElement.classList.remove(this.config.openClassNew);
            document.documentElement.classList.add(this.config.closingClass);
      
            window.setTimeout(function() {
              document.documentElement.classList.remove(this.config.closingClass);
              if (this.activeSource && this.activeSource.getAttribute('aria-expanded')) {
                this.activeSource.setAttribute('aria-expanded', 'false');
                this.activeSource.focus();
              }
            }.bind(this), 500);
      
            this.isOpen = false;
      
            theme.a11y.removeTrapFocus({
              container: this.drawer,
              namespace: 'drawer_focus'
            });
      
            this.unbindEvents();
          },
      
          bindEvents: function() {
            // Clicking out of drawer closes it
            window.on('click' + this.config.namespace, function(evt) {
              this.close(evt)
              return;
            }.bind(this));
      
            // Pressing escape closes drawer
            window.on('keyup' + this.config.namespace, function(evt) {
              if (evt.keyCode === 27) {
                this.close();
              }
            }.bind(this));
      
            theme.a11y.lockMobileScrolling(this.config.namespace, this.nodes.page);
          },
      
          unbindEvents: function() {
            window.off('click' + this.config.namespace);
            window.off('keyup' + this.config.namespace);
      
            theme.a11y.unlockMobileScrolling(this.config.namespace, this.nodes.page);
          }
        });
      
        return Drawers;
    })();

    theme.Currency = (function() {
        var moneyFormat = '${{amount}}';
        var superScript = theme && theme.settings && theme.settings.superScriptPrice;
      
        function formatMoney(cents, format) {
          if (!format) {
            format = theme.settings.moneyFormat;
          }
      
          if (typeof cents === 'string') {
            cents = cents.replace('.', '');
          }
          var value = '';
          var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
          var formatString = (format || moneyFormat);
      
          function formatWithDelimiters(number, precision, thousands, decimal) {
            precision = theme.utils.defaultTo(precision, 2);
            thousands = theme.utils.defaultTo(thousands, ',');
            decimal = theme.utils.defaultTo(decimal, '.');
      
            if (isNaN(number) || number == null) {
              return 0;
            }
      
            number = (number / 100.0).toFixed(precision);
      
            var parts = number.split('.');
            var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
            var centsAmount = parts[1] ? (decimal + parts[1]) : '';
      
            return dollarsAmount + centsAmount;
          }
      
          switch (formatString.match(placeholderRegex)[1]) {
            case 'amount':
              value = formatWithDelimiters(cents, 2);
      
              if (superScript && value && value.includes('.')) {
                value = value.replace('.', '<sup>') + '</sup>';
              }
      
              break;
            case 'amount_no_decimals':
              value = formatWithDelimiters(cents, 0);
              break;
            case 'amount_with_comma_separator':
              value = formatWithDelimiters(cents, 2, '.', ',');
      
              if (superScript && value && value.includes(',')) {
                value = value.replace(',', '<sup>') + '</sup>';
              }
      
              break;
            case 'amount_no_decimals_with_comma_separator':
              value = formatWithDelimiters(cents, 0, '.', ',');
              break;
            case 'amount_no_decimals_with_space_separator':
              value = formatWithDelimiters(cents, 0, ' ');
              break;
          }
      
          return formatString.replace(placeholderRegex, value);
        }
      
        function getBaseUnit(variant) {
          if (!variant) {
            return;
          }
      
          if (!variant.unit_price_measurement || !variant.unit_price_measurement.reference_value) {
            return;
          }
      
          return variant.unit_price_measurement.reference_value === 1
            ? variant.unit_price_measurement.reference_unit
            : variant.unit_price_measurement.reference_value +
                variant.unit_price_measurement.reference_unit;
        }
      
        return {
          formatMoney: formatMoney,
          getBaseUnit: getBaseUnit
        }
    })();

    theme.PriceRange = (function () {
        var defaultStep = 10;
        var selectors = {
          priceRange: '.price-range',
          priceRangeSlider: '.price-range__slider',
          priceRangeInputMin: '.price-range__input-min',
          priceRangeInputMax: '.price-range__input-max',
          priceRangeDisplayMin: '.price-range__display-min',
          priceRangeDisplayMax: '.price-range__display-max',
        };
      
        function PriceRange(container, {onChange, onUpdate, ...sliderOptions} = {}) {
          this.container = container;
          this.onChange = onChange;
          this.onUpdate = onUpdate;
          this.sliderOptions = sliderOptions || {};
      
          return this.init();
        }
      
        PriceRange.prototype = Object.assign({}, PriceRange.prototype, {
          init: function () {
            if (!this.container.classList.contains('price-range')) {
              throw new Error('You must instantiate PriceRange with a valid container')
            }
      
            this.formEl = this.container.closest('form');
            this.sliderEl = this.container.querySelector(selectors.priceRangeSlider);
            this.inputMinEl = this.container.querySelector(selectors.priceRangeInputMin);
            this.inputMaxEl = this.container.querySelector(selectors.priceRangeInputMax);
            this.displayMinEl = this.container.querySelector(selectors.priceRangeDisplayMin);
            this.displayMaxEl = this.container.querySelector(selectors.priceRangeDisplayMax);
      
            this.minRange = parseFloat(this.container.dataset.min) || 0;
            this.minValue = parseFloat(this.container.dataset.minValue) || 0;
            this.maxRange = parseFloat(this.container.dataset.max) || 100;
            this.maxValue = parseFloat(this.container.dataset.maxValue) || this.maxRange;
      
            return this.createPriceRange();
          },
      
          createPriceRange: function () {
            if (this.sliderEl && this.sliderEl.noUiSlider && typeof this.sliderEl.noUiSlider.destroy === 'function') {
              this.sliderEl.noUiSlider.destroy();
            }
      
            var slider = noUiSlider.create(this.sliderEl, {
              connect: true,
              step: defaultStep,
              ...this.sliderOptions,
              // Do not allow overriding these options
              start: [this.minValue, this.maxValue],
              range: {
                min: this.minRange,
                max: this.maxRange,
              },
            });
      
            slider.on('update', values => {
              this.displayMinEl.innerHTML = theme.Currency.formatMoney(
                values[0],
                theme.settings.moneyFormat,
              );
              this.displayMaxEl.innerHTML = theme.Currency.formatMoney(
                values[1],
                theme.settings.moneyFormat,
              );
      
              if (this.onUpdate) {
                this.onUpdate(values);
              }
            });
      
            slider.on('change', values => {
              this.inputMinEl.value = values[0];
              this.inputMaxEl.value = values[1];
      
              if (this.onChange) {
                const formData = new FormData(this.formEl);
                this.onChange(formData);
              }
            });
      
            return slider;
          },
        });
      
        return PriceRange;
    })();

    theme.AjaxRenderer = (function () {
        function AjaxRenderer({ sections, onReplace, debug } = {}) {
          this.sections = sections || [];
          this.cachedSections = [];
          this.onReplace = onReplace;
          this.debug = Boolean(debug);
        }
      
        AjaxRenderer.prototype = Object.assign({}, AjaxRenderer.prototype, {
          renderPage: function (basePath, newParams, updateURLHash = true, isSorting) {
            const currentParams = new URLSearchParams(window.location.search);
            const updatedParams = this.getUpdatedParams(currentParams, newParams, isSorting)
      
            const sectionRenders = this.sections.map(section => {
      
              const url = `${basePath}?section_id=${section.sectionId}&${updatedParams.toString()}`;
              const cachedSectionUrl = cachedSection => cachedSection.url === url;
      
              return this.cachedSections.some(cachedSectionUrl)
                ? this.renderSectionFromCache(cachedSectionUrl, section)
                : this.renderSectionFromFetch(url, section);
            });
      
            if (updateURLHash) this.updateURLHash(updatedParams);
      
            return Promise.all(sectionRenders);
          },
      
          renderSectionFromCache: function (url, section) {
            const cachedSection = this.cachedSections.find(url);
      
            this.log(`[AjaxRenderer] rendering from cache: url=${cachedSection.url}`);
            this.renderSection(cachedSection.html, section);

            document.dispatchEvent(new CustomEvent('collection-grid-item:init'));
            return Promise.resolve(section);
          },
      
          renderSectionFromFetch: function (url, section) {
            this.log(`[AjaxRenderer] redering from fetch: url=${url}`);
            return new Promise((resolve, reject) => {
              fetch(url)
                .then(response => response.text())
                .then(responseText => {
                  const html = responseText;
                  this.cachedSections = [...this.cachedSections, { html, url }];
                  this.renderSection(html, section);
                  resolve(section);
    
                  document.dispatchEvent(new CustomEvent('collection-grid-item:init'));
                })
                .catch(err => reject(err));
            });
          },
      
          renderSection: function (html, section) {
            this.log(
              `[AjaxRenderer] rendering section: section=${JSON.stringify(section)}`,
            );
      
            const newDom = new DOMParser().parseFromString(html, 'text/html');
            if (this.onReplace) {
              this.onReplace(newDom, section);
            } else {
              if (typeof section.nodeId === 'string') {
                var newContentEl = newDom.getElementById(section.nodeId);
                if (!newContentEl) {
                  return;
                }
      
                document.getElementById(section.nodeId).innerHTML =
                  newContentEl.innerHTML;
              } else {
                section.nodeId.forEach(id => {
                  document.getElementById(id).innerHTML =
                    newDom.getElementById(id).innerHTML;
                });
              }
            };
      
            return section;
          },
      
          getUpdatedParams: function (currentParams, newParams, isSorting = false) {
            let clone;
    
            if (!isSorting) {
              clone = new URLSearchParams(currentParams);
            }else {
              clone = new URLSearchParams(newParams);
            };
    
            const preservedParams = ['sort_by', 'q', 'options[prefix]', 'type'];
      
            // Find what params need to be removed
            // delete happens first as we cannot specify keys based off of values
            for (const [key, value] of clone.entries()) {
              if (!newParams.getAll(key).includes(value) && !preservedParams.includes(key)) {
                clone.delete(key);
              };
            }
    
            // Find what params need to be added
            if (!isSorting) {
              for (const [key, value] of newParams.entries()) {
                if (!clone.getAll(key).includes(value) && value !== '') {
                  clone.append(key, value);
                }
              }
            }
      
            return clone;
          },
      
          updateURLHash: function (searchParams) {
            history.pushState(
              {},
              '',
              `${window.location.pathname}${
                searchParams && '?'.concat(searchParams)
              }`,
            );
          },
      
          log: function (...args) {
            if (this.debug) {
              console.log(...args);
            }
          },
        });
      
        return AjaxRenderer;
    })();

    theme.CollectionSidebar = (function() {
        var drawerStyle = false;
        var selectors = {
        sidebar: '#CollectionSidebar',
        };
    
        function CollectionSidebar(container) {
        this.container = container.querySelector(selectors.sidebar);
        }
    
        CollectionSidebar.prototype = Object.assign({}, CollectionSidebar.prototype, {
        init: function() {
            // Do not load when no sidebar exists
            if(!this.container) {
            return;
            }
    
            this.onUnload();
    
            drawerStyle = this.container.dataset.style === 'drawer';
            theme.FilterDrawer = new theme.Drawers('FilterDrawer', 'collection-filters', true);
        },
    
        forceReload: function() {
            this.init();
        },
    
        onSelect: function() {
            if (theme.FilterDrawer) {
            if (!drawerStyle) {
                theme.FilterDrawer.close();
                return;
            }
    
            if (drawerStyle || theme.config.bpSmall) {
                theme.FilterDrawer.open();
            }
            }
        },
    
        onDeselect: function() {
            if (theme.FilterDrawer) {
            theme.FilterDrawer.close();
            }
        },
    
        onUnload: function() {
            if (theme.FilterDrawer) {
            theme.FilterDrawer.close();
            }
        }
        });
  
        return CollectionSidebar;
    })();
  
    theme.Collection = (function() {
        var isAnimating = false;
    
        var selectors = {
        sortSelect: '#SortBy',
    
        colorSwatchImage: '.grid-product__color-image',
        colorSwatch: '.color-swatch--with-image',
    
        collectionGrid: '.collection-grid__wrapper',
        trigger: '.collapsible-trigger',
        sidebar: '#CollectionSidebar',
        filterSidebar: '.collapsible-content--sidebar',
        activeTagList: '.tag-list--active-tags',
        tags: '.tag-list input',
        activeTags: '.tag-list a',
        tagsForm: '.filter-form',
        filters: '.collection-filter',
        priceRange: '.price-range',
        };
    
        var classes = {
        activeTag: 'tag--active',
        removeTagParent: 'tag--remove',
        filterSidebar: 'collapsible-content--sidebar',
        isOpen: 'is-open',
        };
    
        function Collection(container) {
        this.container = container;
        this.sectionId = container.getAttribute('data-section-id');
        this.namespace = '.collection-' + this.sectionId;
        this.sidebar = new theme.CollectionSidebar(container);
        this.context = container.getAttribute('data-context');
        this.ajaxRenderer = new theme.AjaxRenderer({
            sections: [
            {
                sectionId: this.sectionId,
                nodeId: 'CollectionAjaxContent',
            },
            ],
            onReplace: this.onReplaceAjaxContent.bind(this),
        });
    
        this.init();
        this.initCustomEvent();

        document.addEventListener('collection:init', function() {
            this.init();
        }.bind(this));

        }
    
        Collection.prototype = Object.assign({}, Collection.prototype, {
        init: function() {
    
            /* Prevent extra JS from running for featured collection on a collection template */
            if (this.context && this.context === 'featured-collection') {
            this.colorSwatchHovering();
            } else {
            this.initSort();
            this.colorSwatchHovering();
            this.initFilters();
            this.initPriceRange();
            this.sidebar.init();
            }
        },

        initCustomEvent: function() {
            
            document.addEventListener('updateScroll:init', function() {
            this.updateScroll(true)
            }.bind(this));

            document.addEventListener('startLoading:init', function() {
            this.startLoading();
            }.bind(this));

            document.addEventListener('renderCollectionPage', function(e) {
            this.renderCollectionPage(e.detail.newUrl, true, true);
            }.bind(this));
        },
    
        initSort: function() {
            this.sortSelect = document.querySelector(selectors.sortSelect);
    
            if (this.sortSelect) {
            this.defaultSort = this.getDefaultSortValue();
            this.sortSelect.on('change' + this.namespace, this.onSortChange.bind(this));
            }
        },
    
        getSortValue: function() {
            return this.sortSelect.value || this.defaultSort;
        },
    
        getDefaultSortValue: function() {
            return this.sortSelect.getAttribute('data-default-sortby');
        },
    
        onSortChange: function() {
            this.queryParams = new URLSearchParams(window.location.search);
    
            this.queryParams.set('sort_by', this.getSortValue());
            this.queryParams.delete('page'); // Delete if it exists

            window.location.search = this.queryParams.toString();
        },
    
        colorSwatchHovering: function() {
            var colorImages = this.container.querySelectorAll(selectors.colorSwatchImage);
            if (!colorImages.length) {
            return;
            }
    
            this.container.querySelectorAll(selectors.colorSwatch).forEach(swatch => {
            swatch.addEventListener('mouseenter', () => {
                var id = swatch.dataset.variantId;
                var image = swatch.dataset.variantImage;
                var el = this.container.querySelector('.grid-product__color-image--' + id);
                el.style.backgroundImage = 'url(' + image + ')';
                el.classList.add('is-active');
            });
            swatch.addEventListener('mouseleave', () => {
                var id = swatch.dataset.variantId;
                this.container.querySelector('.grid-product__color-image--' + id).classList.remove('is-active');
            });
            });
        },
    
        /*====================
            Collection filters
        ====================*/
        initFilters: function() {
            var tags = document.querySelectorAll(selectors.tags);
    
            if (!tags.length) {
                return;
            }
    
            this.bindBackButton();
    
            // Set mobile top value for filters if sticky header enabled
            if (theme.config.stickyHeader) {
                this.setFilterStickyPosition();
        
                window.on('resize', theme.utils.debounce(500, this.setFilterStickyPosition));
            }
    
            document.querySelectorAll(selectors.activeTags).forEach(tag => {
                tag.addEventListener('click', this.tagClick.bind(this));
            });
    
            document.querySelectorAll(selectors.tagsForm).forEach(form => {
                form.addEventListener('input', this.onFormSubmit.bind(this));
            });
        },
    
        initPriceRange: function() {
            const priceRangeEls = document.querySelectorAll(selectors.priceRange);
            priceRangeEls.forEach((el) => new theme.PriceRange(el, {
            // onChange passes in formData
            onChange: this.renderFromFormData.bind(this),
            }));
        },
    
        tagClick: function(evt) {
            var el = evt.currentTarget;
    
            if (theme.FilterDrawer) {
                theme.FilterDrawer.close();
            }
    
            // Do not ajax-load collection links
            if (el.classList.contains('no-ajax')) {
                return;
            }
    
            evt.preventDefault();
    
            if (isAnimating) {
                return;
            }
    
            isAnimating = true;
    
            const parent = el.parentNode;
            const newUrl = new URL(el.href);
    
            this.renderActiveTag(parent, el);
            //this.updateScroll(true);
            this.startLoading();
            this.renderCollectionPage(newUrl.searchParams);
        },
    
        onFormSubmit: function(evt) {
            var el = evt.target;
    
            if (theme.FilterDrawer) {
                theme.FilterDrawer.close();
            }
    
            // Do not ajax-load collection links
            if (el.classList.contains('no-ajax')) {
                return;
            }
    
            evt.preventDefault();
            if (isAnimating) {
                return;
            }
    
            isAnimating = true;
    
            const parent = el.closest('li');
            const formEl = el.closest('form');
            const formData = new FormData(formEl);
    
            this.renderActiveTag(parent, el);
            //this.updateScroll(true);
            this.startLoading();
            this.renderFromFormData(formData);
        },
    
        fetchOpenCollasibleFilters: function() {
            return Array.from(
            document.querySelectorAll(
                `${selectors.sidebar} ${selectors.trigger}.${classes.isOpen}`,
            ),
            ).map(trigger => trigger.dataset.collapsibleId);
        },
    
        renderActiveTag: function(parent, el) {
            const textEl = parent.querySelector('.tag__text');
    
            if (parent.classList.contains(classes.activeTag)) {
            parent.classList.remove(classes.activeTag);
            } else {
            parent.classList.add(classes.activeTag);
    
            // If adding a tag, show new tag right away.
            // Otherwise, remove it before ajax finishes
            if (el.closest('li').classList.contains(classes.removeTagParent)) {
                parent.remove();
            } else {
                // Append new tag in both drawer and sidebar
                document.querySelectorAll(selectors.activeTagList).forEach(list => {
                const newTag = document.createElement('li');
                const newTagLink = document.createElement('a');
                newTag.classList.add('tag', 'tag--remove');
                newTagLink.classList.add('btn', 'btn--small');
                newTagLink.innerText = textEl.innerText;
                newTag.appendChild(newTagLink);
    
                list.appendChild(newTag);
                });
            }
            }
        },
    
        renderFromFormData: function(formData) {
            const searchParams = new URLSearchParams(formData);
            this.renderCollectionPage(searchParams);
        },
    
        onReplaceAjaxContent: function(newDom, section) {
            const openCollapsibleIds = this.fetchOpenCollasibleFilters();
    
            openCollapsibleIds.forEach(selector => {
            newDom
                .querySelectorAll(`[data-collapsible-id=${selector}]`)
                .forEach(this.openCollapsible);
            });
    
            var newContentEl = newDom.getElementById(section.nodeId);
            if (!newContentEl) {
            return;
            }
    
            document.getElementById(section.nodeId).innerHTML = newContentEl.innerHTML;
        },
    
        openCollapsible: function(el) {
            if (el.classList.contains(classes.filterSidebar)) {
            el.style.height = 'auto';
            }
    
            el.classList.add(classes.isOpen);
        },
    
        renderCollectionPage: function(searchParams, updateURLHash = true, isSorting = false) {
            this.ajaxRenderer
            .renderPage(window.location.pathname, searchParams, updateURLHash, isSorting)
            .then(() => {
                theme.sections.reinit('collection-grid');
                //this.updateScroll(false);
                this.initPriceRange();
                theme.collapsibles.init();
    
                document.dispatchEvent(new CustomEvent('collection:reloaded'));
                document.dispatchEvent(new CustomEvent('atc-init'));
                document.dispatchEvent(new CustomEvent('layout-btns:init'));
                document.dispatchEvent(new CustomEvent("product-media-slider:init"));
                document.dispatchEvent(new CustomEvent('ajax-pagination:init'));
                
                isAnimating = false;
            });
        },
    
        bindBackButton: function() {
            // Ajax page on back button
            window.off('popstate' + this.namespace);
            window.on('popstate' + this.namespace, function(state) {
            if (state) {
                const newUrl = new URL(window.location.href);
                this.renderCollectionPage(newUrl.searchParams, false);
            }
            }.bind(this));
        },
    
        updateScroll: function(animate) {
            var scrollToElement = document.querySelector('[data-scroll-to]');
            var scrollTo = scrollToElement && scrollToElement.offsetTop;
    
            if (!theme.config.bpSmall) {
            scrollTo -= 15;
            }
    
            if (theme.config.stickyHeader) {
                var headerHeight = document.querySelector('.site-header').offsetHeight;
                scrollTo = scrollTo - headerHeight;
            }
    
            if (animate) {
            window.scrollTo({top: scrollTo, behavior: 'smooth'});
            } else {
            window.scrollTo({top: scrollTo});
            }
        },
    
        setFilterStickyPosition: function() {
            var headerHeight = document.querySelector('.site-header').offsetHeight;
            document.querySelector(selectors.filters).style.top = headerHeight + 10 + 'px';
    
            // Also update top position of sticky sidebar
            var stickySidebar = document.querySelector('.grid__item--sidebar');
            if (stickySidebar) {
            stickySidebar.style.top = headerHeight + 10 + 'px';
            }
        },
    
        forceReload: function() {
            this.init();
        },
    
        startLoading: function() {
            document.querySelector(selectors.collectionGrid).classList.add('unload');
        },
        });
    
        return Collection;
    })();

    theme.initGlobals = function() {
      theme.collapsibles.init();
    }

    function DOMready(callback) {
        if (document.readyState != 'loading') callback();
        else document.addEventListener('DOMContentLoaded', callback);
    }

    DOMready(function(){
        theme.sections = new theme.Sections();
        theme.sections.register('collection-grid', theme.Collection);
        theme.initGlobals();
    });
})();

const mainCollection = document.querySelector("[js-main-collection]");

if(mainCollection) {
  function initLayoutBtns() {
    const layoutBtns = document.querySelectorAll("[js-layout-btn]");
    if(!layoutBtns) return;

    mainCollection.querySelector(`[data-grid="${mainCollection.dataset.grid}"]`).classList.add("active");
    layoutBtns.forEach( layoutBtn => layoutBtn.addEventListener('click', toggleLayout));

    function toggleLayout() {
      const grid = this.dataset.grid;

      layoutBtns.forEach( btn => btn.classList.remove("active"));
      this.classList.add("active");
      mainCollection.setAttribute("data-grid", grid);
    }
  };

  initLayoutBtns();
  document.addEventListener("layout-btns:init", initLayoutBtns);
}